import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex column gap-12"
}
const _hoisted_2 = {
  key: 1,
  class: "gap-sm flex row no-wrap items-center justify-between"
}
const _hoisted_3 = { class: "block text-cool-gray-60 fs-13px fw-400" }

import { computed } from 'vue'
import translate from 'src/common/helpers/language/translate'
import globalTranslateObject from 'src/translate/global.translate'
import { IAddress } from 'src/common/interfaces'

interface IProps {
  title: string
  address: IAddress
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseSidePanelAddress' },
  __name: 'BaseSidePanelAddress',
  props: {
    title: {},
    address: {}
  },
  setup(__props: any) {


const props = __props

const { t: globalT } = translate(globalTranslateObject)

const isAddressEmpty = computed(() => {
  return (
    !props.address.line1 &&
    !props.address.line2 &&
    !props.address.city &&
    !props.address.postcode &&
    !props.address.country
  )
})

return (_ctx: any,_cache: any) => {
  const _component_BaseSidePanelRecord = _resolveComponent("BaseSidePanelRecord")!
  const _component_BaseSidePanelSection = _resolveComponent("BaseSidePanelSection")!

  return (_openBlock(), _createBlock(_component_BaseSidePanelSection, {
    title: __props.title,
    class: "BaseSidePanelAddress"
  }, {
    default: _withCtx(() => [
      (!isAddressEmpty.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_BaseSidePanelRecord, {
              border: false,
              "fixed-height": false,
              value: __props.address.line1
            }, null, 8 /* PROPS */, ["value"]),
            _createVNode(_component_BaseSidePanelRecord, {
              border: false,
              "fixed-height": false,
              value: __props.address.line2
            }, null, 8 /* PROPS */, ["value"]),
            _createVNode(_component_BaseSidePanelRecord, {
              border: false,
              "fixed-height": false,
              value: __props.address.city
            }, null, 8 /* PROPS */, ["value"]),
            _createVNode(_component_BaseSidePanelRecord, {
              border: false,
              "fixed-height": false,
              value: __props.address.postcode
            }, null, 8 /* PROPS */, ["value"]),
            _createVNode(_component_BaseSidePanelRecord, {
              border: false,
              "fixed-height": false,
              value: __props.address.country
            }, null, 8 /* PROPS */, ["value"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "no-data", {}, () => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(globalT)('no_address')), 1 /* TEXT */)
            ])
          ]))
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["title"]))
}
}

})